import { render, staticRenderFns } from "./LpOrdering.vue?vue&type=template&id=30f703e2&scoped=true"
import script from "./LpOrdering.vue?vue&type=script&lang=js"
export * from "./LpOrdering.vue?vue&type=script&lang=js"
import style0 from "./LpOrdering.vue?vue&type=style&index=0&id=30f703e2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f703e2",
  null
  
)

export default component.exports